import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What technologies do you specialize in?",
      answer: "We specialize in modern full-stack development using React, Next.js, Node.js, and Python. We also have deep expertise in AI integration (OpenAI, LangChain) and cloud infrastructure (AWS, Vercel)."
    },
    {
      question: "How long does a typical project take?",
      answer: "Project timelines vary based on complexity. A custom dashboard might take 4-6 weeks, while a full-scale SaaS platform could take 3-6 months. We work in agile sprints to ensure regular delivery of value."
    },
    {
      question: "Do you offer post-launch support?",
      answer: "Yes, we provide flexible maintenance and support packages to ensure your application remains secure, up-to-date, and performs optimally as your user base grows."
    },
    {
      question: "How do you handle project security?",
      answer: "Security is built into our core process. We implement industry best practices, including secure authentication, data encryption, regular dependency audits, and automated security testing in our CI/CD pipelines."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Common <span>Questions</span></h2>
          <p className="section-subtitle">Everything you need to know about working with us.</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item ${activeIndex === i ? 'active' : ''}`}>
              <button className="faq-question" onClick={() => toggleFAQ(i)}>
                <span>{faq.question}</span>
                {activeIndex === i ? <Minus size={20} /> : <Plus size={20} />}
              </button>
              <AnimatePresence>
                {activeIndex === i && (
                  <motion.div 
                    className="faq-answer"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
